import api from "../../../services/api";

export interface BirthdayPerson {
  id: number;
  name: string;
  designation: string;
  profile_pic: string | null;
  date: string;
  daysUntil: number;
  isToday: boolean;
  isSelf: boolean;
  /** Completed years of service — present only on anniversary entries. */
  years?: number;
}

export interface UpcomingBirthdays {
  all: BirthdayPerson[];
  anniversaries: BirthdayPerson[];
  todayKey: string;
}

let inflight: Promise<UpcomingBirthdays> | null = null;

export const fetchUpcomingBirthdays = (): Promise<UpcomingBirthdays> => {
  if (inflight) return inflight;

  const promise = (async (): Promise<UpcomingBirthdays> => {
    const signature = localStorage.getItem("signature");
    const res = await api.post("userService/getUpcomingBirthdays", {
      signature,
    });
    const data = res?.data?.data?.data;
    if (!data || !Array.isArray(data.all)) {
      console.warn("[birthday] unexpected response shape", res?.data);
      return { all: [], anniversaries: [], todayKey: "" };
    }
    return {
      all: data.all as BirthdayPerson[],
      anniversaries: Array.isArray(data.anniversaries)
        ? (data.anniversaries as BirthdayPerson[])
        : [],
      todayKey: data.todayKey || "",
    };
  })();

  promise.catch(() => {
    inflight = null;
  });

  inflight = promise;
  return promise;
};
